// extracted by mini-css-extract-plugin
module.exports = {"points":"bnpl-card_points__XW1HA","sub_text":"bnpl-card_sub_text__xmU0u","points_container":"bnpl-card_points_container__MvQf9"};